import { createSlice } from "@reduxjs/toolkit";
import appApi from "../api";

type Rentals = {
  id: string;
  deviceName: string;
  type: string;
  price: string;
};

type RentalState = {
  rentals: Rentals[];
  loading: boolean;
  error: string | null;
};
const initialState: RentalState = {
  rentals: [],
  loading: false,
  error: null,
};
const rentalSlice = createSlice({
  name: "rentals",
  initialState,
  reducers: {
    setRentals: (state, action) => {
      state.rentals = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        appApi.endpoints.fetchRentals.matchFulfilled,
        (state, action) => {
          state.rentals = action.payload;
          state.loading = false;
          state.error = null;
        }
      )
    }
});
export const { setRentals, } = rentalSlice.actions;
export default  rentalSlice.reducer;
export const getRentals = (state: { rentals: RentalState }) => state.rentals.rentals;
// export const selectLoading = (state: { office: OfficeState }) => state.office.loading;
